import { render, staticRenderFns } from "./preCode.vue?vue&type=template&id=42a5cfd0&scoped=true&"
import script from "./preCode.vue?vue&type=script&lang=js&"
export * from "./preCode.vue?vue&type=script&lang=js&"
import style0 from "./preCode.vue?vue&type=style&index=0&id=42a5cfd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a5cfd0",
  null
  
)

export default component.exports